export default [
  {
    text: '名称',
    value: 'name'
  },
  {
    text: '住所',
    cssClass: 'text-xs-left',
    value: 'address'
  },
  {
    text: 'タンク容量 (L)',
    cssClass: 'text-xs-center strong',
    value: 'legalMax'
  },
  {
    text: '残量 (L)',
    value: 'rest',
    cssClass: 'text-xs-center font-weight-bold text-no-wrap',
    type: 'multi'
  },
  {
    text: '補給猶予',
    value: 'margin',
    cssClass: 'text-xs-center',
    type: 'colored'
  },
  {
    text: 'データ取得時刻',
    cssClass: 'text-xs-right',
    value: 'volumeUpdatedAt'
  },
  {
    text: 'タンク',
    value: 'tank'
  },
  {
    text: '配送頻度',
    cssClass: 'text-xs-center strong',
    value: 'deliveryFrequency'
  },
  {
    text: '最終給油日',
    cssClass: 'text-xs-center px-0',
    value: 'lastSuppliedAt'
  },
  {
    text: '最終給油量 (L)',
    cssClass: 'text-xs-center strong',
    value: 'lastSuppliedAmount'
  }
]
